// extracted by mini-css-extract-plugin
export var root = "Service-module--root---3V7F";
export var left = "Service-module--left--lkGod";
export var box = "Service-module--box--3COeF";
export var btn = "Service-module--btn--2iyd6";